import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import Add from '@mui/icons-material/Add';

import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';

import getLearningObjectivesMenuItems from '../helpers/getLearningObjectivesMenuItems';

const LearningObjectivesListItemActions = ({
  item,
  onActionItemClick,
}) => {
  const options = getLearningObjectivesMenuItems({ 'add': onActionItemClick });

  return (
    <Menu
      horizontalPosition="left"
      shouldAnimate={false}
      testId={`learning-objectives-list-item-actions-${item.id}`}
      component={
        <Button
          size="xsmall"
          variant="ghost"
          icon={<Add />}
          aria-label={i18n.t('learning-objectives.add')}
        />
      }
    >
      {options}
    </Menu>
  );
};

LearningObjectivesListItemActions.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  onActionItemClick: PropTypes.func.isRequired,
};

export default React.memo(LearningObjectivesListItemActions);
